var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsEarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 9.5,
    fill: "#B6C0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 7.91663H12.3333",
    stroke: "#1434CB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3608 8.75H19.1925C17.705 8.75 16.5 9.86917 16.5 11.25C16.5 12.6308 17.7058 13.75 19.1917 13.75H21.3608C21.4308 13.75 21.465 13.75 21.4942 13.7483C21.9442 13.7208 22.3025 13.3883 22.3317 12.9708C22.3333 12.9442 22.3333 12.9117 22.3333 12.8475V9.6525C22.3333 9.58833 22.3333 9.55583 22.3317 9.52917C22.3017 9.11167 21.9442 8.77917 21.4942 8.75167C21.465 8.75 21.4308 8.75 21.3608 8.75Z",
    stroke: "#1434CB",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4709 8.75004C21.4059 7.19004 21.1976 6.23337 20.5234 5.56004C19.5476 4.58337 17.9759 4.58337 14.8334 4.58337H12.3334C9.19091 4.58337 7.61925 4.58337 6.64341 5.56004C5.66758 6.53671 5.66675 8.10754 5.66675 11.25C5.66675 14.3925 5.66675 15.9642 6.64341 16.94C7.62008 17.9159 9.19091 17.9167 12.3334 17.9167H14.8334C17.9759 17.9167 19.5476 17.9167 20.5234 16.94C21.1976 16.2667 21.4067 15.31 21.4709 13.75",
    stroke: "#1434CB",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 4.58333L12.1125 2.51916C12.5503 2.23475 13.0612 2.08337 13.5833 2.08337C14.1054 2.08337 14.6163 2.23475 15.0542 2.51916L18.1667 4.58333",
    stroke: "#1434CB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.9927 11.25H19.0002",
    stroke: "#1434CB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsEarning);
export default __webpack_public_path__ + "static/media/insights-earning.30aa4f7c74d1dc67b6b041a56d821bd0.svg";
export { ForwardRef as ReactComponent };